<template>
    <div id="app">
        <v-app id="inspire">
            <v-card-title>
                <span class="headline">Perfil</span>
            </v-card-title>
            <v-container grid-list-xl>
                <v-form
                ref="form"
                v-model="valid"
                lazy-validation>
                    <v-layout
                        class="mt-3"
                        row
                        align-end
                        justify-space-between
                    >
                         <v-flex xs12 sm12 md5>
                            <v-text-field v-model="nome" label="Nome" readonly></v-text-field>
                        </v-flex>
                         <v-flex xs12 sm12 md5>
                            <v-text-field v-model="telefone" label="Telefone" readonly></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout
                        row
                        align-end
                        justify-space-between
                    >
                         <v-flex xs12 sm12 md5>
                            <v-text-field v-model="email" label="E-mail" readonly></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md5>
                            <v-text-field  :append-icon="show3 ? 'visibility' : 'visibility_off'"  :type="show3 ? 'text' : 'password'" class="input-group--focused" @click:append="show3 = !show3" v-model="senhaMudar" label="Senha" counter="8" :rules="obgRules" required></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-form>
                <v-layout
                    class="mt-4"
                    row
                    align-end
                >
                    <v-btn
                    class="ml-2"
                    color="success"
                    @click="mudarSenha"
                    >
                    Salvar
                    </v-btn>
                </v-layout>
                <v-layout
                    class="mt-4">
                    <v-flex xs12 md12>
                        <v-textarea
                            v-if="this.envio !== ''"
                            disabled
                            outline
                            no-resize
                            rows = "5"
                            name="inputEnvio"
                            label="Envio"
                            :value="envio"
                        ></v-textarea>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs12 md12>
                        <v-textarea
                            v-if="this.mostrar !== ''"
                            disabled
                            outline
                            no-resize
                            color="purple"
                            rows = "5"
                            name="inputMostrar"
                            label="Resposta"
                            :value="mostrar"
                        ></v-textarea>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-app>
    </div>
</template>

<script>
    import {sharedService} from '../services'

    export default {
        name: 'Perfil',
        data() {
            return {
                show3: false,
                mostrar: '',
                envio: '',
                usuario: '',
                nome: '',
                email: '',
                telefone: '',
                senhaMudar: '',
                valid: true,
                text: '',
                obgRules: [
                    v => !!v || 'Este campo é obrigatório',
                ]
            }
        },
        methods: {
            mudarSenha() {
                let self = this
                this.$confirm('Tem certeza que deseja salvar este item?').then(res => {
                    if (res) {
                        if (this.$refs.form.validate()) { 
                            sharedService.create('do/trocaSenha', {id: this.usuario.usuario.id, senha: this.senhaMudar}).then(function (obj){
                                self.envio = JSON.stringify({id: self.usuario.usuario.id, senha: self.senhaMudar})
                                obj.text().then(function (text){
                                    self.mostrar = text
                                    if(obj.status === 200){
                                        self.$store.dispatch('success', 'Senha alterada com sucesso!')
                                    }  else {
                                        self.$store.dispatch('error', text)
                                    }
                                })
                            })
                        } 
                    } else {
                        this.close()
                    }
                })
            },
            getData() {
                this.usuario = this.$store.getters.getUser
                this.nome = this.usuario.usuario.nome
                this.telefone = this.usuario.usuario.telefone
                this.email = this.usuario.usuario.email
            }   
        },
        beforeMount(){
            this.getData()
        }
    }
</script>

<style scoped>

</style>
